export const rowHeight = 31

export const rowsPerPage = 10
